
import UnsaveGuardMixin from '@/components/UnsaveGuardMixin';

import { Component, Ref } from 'vue-property-decorator';
import carList from '@/views/carModule/components/carTableList.vue';
import lazyInject from '@/di';
import CarService from '@/services/car.service';
import CarShopEditor from './components/CarShopEditor.vue';
import { component as Viewer } from 'v-viewer';
import { ECarShopField } from '@/common/enum/carShop';
import LocationView from '@/views/shop/components/LocationView.vue';
import UTILService from '@/services/utils.service';
import VideoUModal from '@/components/video/VideoModal.vue';
import BusinessStatusControl from './components/BusinessStatusControl.vue';
import { EShopBusinessStatusNum, EShopBusinessPOI } from '@/common/enum/shop';
import {
  IEditShopFieldAddress,
  MerchantSettledEnumCar,
} from '@/common/interface/shop';
import LookCarPhone from '@/components/LookCarPhone.vue';
import ImageService from '@/services/image.service';
import SystemService from '@/services/system.service';
import { AuthEnum } from '@/services/permission.service';
import ShoplLicenseModal from '@/views/shop/components/ShoplLicenseModal.vue';
import IDcardModal from '@/views/shop/components/IDcardModal.vue';
import AlbumManagement from './components/AlbumManagement.vue';
import MarketDrawer from './components/field/MarketDrawer.vue';
import OperatingData from './components/OperatingData.vue';
import ShopInspectionRecord from './components/ShopInspectionRecord.vue';
import MultipleModal from './components/MultipleModal.vue';
import RevisionRecordTable from './components/RevisionRecordTable.vue';
import ChangePoiModal from './components/ChangePoiModal.vue';
import { DebounceTime } from '@/common/decorator';
// import {
//   IShopFormField,
// } from '@/common/interface/shop';

@Component({
  components: {
    carList,
    CarShopEditor,
    Viewer,
    LocationView,
    VideoUModal,
    BusinessStatusControl,
    LookCarPhone,
    ShoplLicenseModal,
    IDcardModal,
    AlbumManagement,
    MarketDrawer,
    OperatingData,
    ShopInspectionRecord,
    MultipleModal,
    RevisionRecordTable,
    ChangePoiModal,
  },
})
export default class ShopDetail extends UnsaveGuardMixin {
  @lazyInject(CarService)
  carService!: CarService;

  @Ref()
  shopEditorRef!: CarShopEditor;

  @Ref()
  marketDrawerRef!: MarketDrawer;

  @Ref('lookCarPhone')
  lookCarPhone!: LookCarPhone;

  @Ref('shopInspectionRecord')
  shopInspectionRecord!: ShopInspectionRecord;

  @Ref('operatingData')
  operatingData!: OperatingData;

  @Ref('changePoiModal')
  changePoiModal!: ChangePoiModal;

  @Ref('multipleModal')
  multipleModal!: MultipleModal;

  @Ref('revisionRecordTable')
  revisionRecordTable!: RevisionRecordTable;

  AuthEnum = AuthEnum;

  @Ref()
  businessControl!: BusinessStatusControl;

  @Ref()
  videoModal!: VideoUModal;

  @Ref('carList')
  carList!: carList;

  @Ref()
  locationView!: LocationView;

  @lazyInject(UTILService)
  private utilService!: UTILService;

  @lazyInject(ImageService)
  protected imageService!: ImageService;

  @lazyInject(SystemService)
  protected SystemService!: SystemService;

  @Ref('shoplLicenseModal')
  shoplLicenseModal!: ShoplLicenseModal;

  @Ref('idCardModal')
  idCardModal!: IDcardModal;

  @Ref('albumManagement')
  albumManagement!: AlbumManagement;

  ECarShopField = ECarShopField;

  EShopBusinessPOI = EShopBusinessPOI;

  EShopBusinessStatusNum = EShopBusinessStatusNum;

  MerchantSettledEnumCar = MerchantSettledEnumCar;

  businessLicenseInfo: any = {};

  idCardInfo: any = {};

  isLoading = false;

  activeTab = '1';

  shopTotal = '';

  editingField: any = {
    label: '',
    value: '',
    type: '',
    submitAction: '',
  };

  enumeration: any = {
    id: 'id', // id
    carShopCode: 'car_shop_code', // 门店编码
    car_shop_id: 'car_shop_id', // 店铺ID
    poi: 'poi', // poi
    name: 'name', // 店铺名称
    // REGIONPID:'regionpid', // 省ID
    // REGIONID:'regionid', // 区域id
    // ADCODE:'adcode', // 区县ID
    address: 'address', // 地址明细
    startTime: 'start_time', // 第一次开始营业的时间
    area: 'area', // 营业面积
    headPics: 'head_pics', // 店铺头图
    coverPics: 'cover_pics', // 店铺封面图
    pics: 'pics', // 店铺图片
    join_videos: 'join_videos', // 入驻门店视频
    tels: 'tels', // 营业电话
    managerId: 'manager_id', // 联系人身份证
    identityNum: 'identity_num', // 联系人身份证号码
    shopLicense: 'shop_license', // 店铺营业执照
    bossId: 'boss_id', // 联系人ID
    staffId: 'staff_id', // 地推员id
    remark: 'remark', // 备注
    onlineStatus: 'online_status', // 门店状态
    company: 'company', // 公司名称
    reviewStatus: 'review_status', // 审核状态
    onlineGdStatus: 'online_gd_status', // 线上状态
    onlineGdTime: 'online_gd_time', // 线上时间
    businessTime: 'business_time', // 营业时间
    cpId: 'cp_id', // 门店类型
    offlineGdTime: 'offline_gd_time', // 线下时间
    videos: 'videos', // 视频
    maplocation: 'map_location', // 地图位置
    merchantTelephone: 'merchant_telephone', // 行业电话
    otherQualifications: 'other_qualifications',
  };

  addressInfo: IEditShopFieldAddress = {
    address: '',
    regions: [] as number[],
    latitude: '',
    longitude: '',
    locationName: '',
  };

  advertiser = {
    adId: '',
    outAdId: '',
    adPhone: '',
    bossId: 0,
    agentId: null,
    agentName: null,
  };

  lng = '';
  lat = '';
  locationName = '';

  editType = '1';

  multipleData = {};

  shopCode = '';

  get staffList(): any {
    return Object.values(this.staff)
      .map((data: any) => data.data)
      .reduce((prev, cur) => prev.concat(cur), []);
  }

  staff: any = {};

  shopDetail: any = {
    managerId: [],
    shopLicense: [],
  };

  callback(val: any) {
    this.activeTab = val;
    if (val === '3') {
      this.getAlbumShopInfo();
    } else if (val === '4') {
      this.$nextTick(() => {
        this.carList.init(this.shopDetail.carShopId);
      });
    } else if (val === '5') {
      this.$nextTick(() => {
        this.operatingData.init();
      });
    } else if (val === '2') {
      this.$nextTick(() => {
        this.revisionRecordTable.init();
      });
    }
  }

  albumData: any = {};

  async getAlbumShopInfo() {
    // console.log(this.shopCode);
    const res = await this.carService.getCarShopAlbumInfo(
      {
        shopId: this.shopDetail.carShopId as string,
      },
      this.$el,
    );
    // console.log(res);
    this.albumData = res;
    this.$nextTick(() => {
      this.albumManagement.init();
    });
  }

  back() {
    this.$router.push({
      name: 'car.index',
    });
  }

  @DebounceTime()
  async touchSyncShop() {
    if (!this.shopCode) {
      return;
    }
    const res = await this.carService.postCarShopAmapYdSyncAllData({
      shop_code: this.shopCode,
    });
    if (res) {
      this.$message.success('推送成功');
    }
  }

  LookShopDetail(val: any, poi: any, type: string) {
    this.lookCarPhone.init(type, val, poi);
  }

  changePoi(val: any) {
    console.log(val);
    this.changePoiModal.init(val);
  }

  openVideoModal(obj: { url: string; cover: string; id: number }) {
    this.videoModal.open(obj.url);
  }

  editFunType() {
    if (this.editType === '1') {
      this.editType = '2';
      this.$message.success('已开启批量编辑模式');
    } else {
      this.editType = '1';
      this.$message.success('已关闭批量编辑模式');
      this.multipleData = {};
      this.hasUnsavedChanges = false;
    }
  }

  async multiplePieces() {
    // if (!this.shopId) {
    //   return;
    // }
    if (Object.keys(this.multipleData).length === 0) {
      this.$message.error('当前没有修改内容，请先进行编辑操作！');
      return;
    }
    this.multipleModal.init();
    // console.log(this.multipleData);
  }

  async funModifyShop() {
    console.log(this.multipleData);
    const { id } = this.$route.params;
    const params = {
      car_shop_code: id,
      ...this.multipleData,
    };
    try {
      const res = await this.carService.getCarInfoEdit(params);
      if (res) {
        this.$message.success('操作成功');
        this.hasUnsavedChanges = false;
        this.multipleData = {};
        this.init();
      } else {
        this.hasUnsavedChanges = false;
        this.multipleData = {};
      }
    } catch (error) {
      this.$message.error(`${error}`);
    }
  }

  shopFields: any = {
    [`${ECarShopField.NAME}`]: {
      labelName: '店铺名称',
      label: ECarShopField.NAME,
      value: '',
      type: ECarShopField.NAME,
      fieldTitle: '店铺名称',
      submitAction: this.editShop,
    },
    [`${ECarShopField.ADDRESS}`]: {
      labelName: '地址明细',
      label: ECarShopField.ADDRESS,
      value: '',
      type: ECarShopField.ADDRESS,
      fieldTitle: '地址明细',
      width: 1200,
      submitAction: this.editShopAddress,
    },
    [`${ECarShopField.START_TIME}`]: {
      labelName: '开业时间',
      label: ECarShopField.START_TIME,
      value: '',
      type: ECarShopField.START_TIME,
      fieldTitle: '编辑开业时间',
      placeholder: '请选择开业时间',
      submitAction: this.editShop,
    },
    [`${ECarShopField.ADVERTISER_MOBILE_PHONE_NUMBER}`]: {
      labelName: '广告主电话',
      label: ECarShopField.ADVERTISER_MOBILE_PHONE_NUMBER,
      value: '',
      rule: [
        {
          required: true,
          message: '手机号不能为空',
          trigger: 'blur',
        },
        {
          pattern: /1[3-9]\d{9}/,
          message: '请输入正确的手机号',
          trigger: 'blur',
        },
      ],
      type: ECarShopField.ADVERTISER_MOBILE_PHONE_NUMBER,
      fieldTitle: '编辑广告主电话',
      placeholder: '请输入广告主电话',
      submitAction: this.editAdvertiserPhoneNum,
    },
    [`${ECarShopField.BUSINESS_TIME}`]: {
      labelName: '营业时间',
      label: ECarShopField.BUSINESS_TIME,
      value: '',
      type: ECarShopField.BUSINESS_TIME,
      fieldTitle: '营业时间',
      submitAction: this.editShop,
    },
    [`${ECarShopField.MERCHANT_TELEPHONE}`]: {
      labelName: '行业电话',
      label: ECarShopField.MERCHANT_TELEPHONE,
      value: '',
      type: ECarShopField.MERCHANT_TELEPHONE,
      fieldTitle: '行业电话',
      submitAction: this.editShop,
    },
    [`${ECarShopField.TELS}`]: {
      labelName: '营业电话',
      label: ECarShopField.TELS,
      value: '',
      type: ECarShopField.TELS,
      fieldTitle: '营业电话',
      submitAction: this.editShop,
    },
    [`${ECarShopField.MANAGER_ID}`]: {
      labelName: '身份证信息',
      label: ECarShopField.MANAGER_ID,
      value: '',
      type: ECarShopField.MANAGER_ID,
      fieldTitle: '身份证信息',
      submitAction: this.editShop,
    },
    [`${ECarShopField.SHOP_LICENSE}`]: {
      labelName: '营业执照',
      label: ECarShopField.SHOP_LICENSE,
      value: '',
      type: ECarShopField.SHOP_LICENSE,
      fieldTitle: '编辑营业执照',
      submitAction: this.editShopLicense,
    },
    [`${ECarShopField.COVER_PICS}`]: {
      labelName: '封面图片',
      label: ECarShopField.COVER_PICS,
      value: '',
      type: ECarShopField.COVER_PICS,
      fieldTitle: '编辑封面图片',
      submitAction: this.editShop,
    },
    [`${ECarShopField.HEAD_PICS}`]: {
      labelName: '店铺头图',
      label: ECarShopField.HEAD_PICS,
      value: '',
      type: ECarShopField.HEAD_PICS,
      fieldTitle: '编辑店铺头图',
      submitAction: this.editShop,
    },
    [`${ECarShopField.IDENTITY_NUM}`]: {
      labelName: '企业法人身份证号',
      label: ECarShopField.IDENTITY_NUM,
      value: '',
      type: ECarShopField.IDENTITY_NUM,
      fieldTitle: '企业法人身份证号',
      submitAction: this.editShop,
    },
    [`${ECarShopField.MARKET_NAME}`]: {
      labelName: '市场',
      label: ECarShopField.MARKET_NAME,
      value: '',
      type: ECarShopField.MARKET_NAME,
      fieldTitle: '市场',
      submitAction: this.editMarket,
    },
    [`${ECarShopField.PICS}`]: {
      labelName: '店铺图册',
      label: ECarShopField.PICS,
      value: '',
      type: ECarShopField.PICS,
      fieldTitle: '编辑店铺图册',
      submitAction: this.editShop,
    },
    [`${ECarShopField.JOIN_VIDEOS}`]: {
      labelName: '实拍视频',
      label: ECarShopField.JOIN_VIDEOS,
      value: '',
      type: ECarShopField.JOIN_VIDEOS,
      fieldTitle: '编辑实拍视频',
      submitAction: this.editShop,
    },
    [`${ECarShopField.SHOP_USER_RELATIONS}`]: {
      labelName: '店员信息',
      label: ECarShopField.SHOP_USER_RELATIONS,
      value: '',
      type: ECarShopField.SHOP_USER_RELATIONS,
      fieldTitle: '编辑店员信息',
      submitAction: this.editShop,
    },
    [`${ECarShopField.OTHER_QUALIFICATIONS}`]: {
      labelName: '其他补充资质',
      label: ECarShopField.OTHER_QUALIFICATIONS,
      value: '',
      type: ECarShopField.OTHER_QUALIFICATIONS,
      fieldTitle: '其他补充资质《经营地址租赁合同》或《不动产登记证》',
      submitAction: this.editShop,
    },
  };

  copyToClipboard(text: string) {
    this.$copyText(String(text)).then(
      () => {
        this.$message.success('复制成功');
      },
      (err) => {
        this.$message.error(`复制失败:${err}`);
      },
    );
  }

  showLocation() {
    const { longitude, latitude, name } = this.shopDetail;
    this.lng = longitude;
    this.lat = latitude;
    this.locationName = name;
    this.locationView.show();
  }

  refresh() {
    this.init();
  }

  listTatle(val: any) {
    this.shopTotal = val;
  }

  delShopQualifications(shopId: any) {
    const data = this.shopDetail.otherQualifications.map((res: any) => res.id);
    const _a = data.filter((item: any) => item !== shopId);
    const { id } = this.$route.params;
    this.transferModifyShop({
      car_shop_code: id,
      other_qualifications: _a,
    });
  }

  /**
   * 同步推送语音到高德地图
   */
  async syncPushVoiceToAMap() {
    if (!this.shopDetail.carShopId) {
      return;
    }
    const res = await this.carService.shopEcSyncPushVoiceToAMap({
      shop_id: this.shopDetail.carShopId,
    });
    if (res) {
      this.$message.success('操作成功');
    }
  }

  async touchShopMerchant() {
    const res = await this.carService.postCarShopCreateShop(
      this.shopDetail.carShopCode,
    );
    if (res) {
      this.$message.success('操作成功');
      setTimeout(() => {
        this.init();
      }, 2000);
    }
  }

  async intervention() {
    const res = await this.carService.postCarShopQueryStatus(
      this.shopDetail.carShopCode,
    );
    if (res) {
      this.$message.success('操作成功');
      this.init();
    }
  }

  @DebounceTime()
  async shopQueryInfo() {
    if (!this.shopCode) {
      return;
    }
    const res = await this.carService.getCarShopAmapYdQueryInfo(this.shopCode);
    // console.log(res);
    if (res) {
      this.$message.success(res);
      this.init();
    }
  }

  async editShop(param: { [key: string]: any }) {
    const val = Object.entries(param)[0];
    const type = val[0];
    let value = val[1];
    // console.log(val);
    const { id } = this.$route.params;
    if (type === 'headPics' || type === 'coverPics' || type === 'shopLicense') {
      value = value.join(',');
    }

    if (this.editType === '2') {
      this.hasUnsavedChanges = true;
      const Obj = {
        [this.enumeration[type]]: val[1],
      };
      this.multipleData = Object.assign({}, this.multipleData, Obj);
      this.shopEditorRef.close();
      return;
    }
    const data = {
      car_shop_code: id,
      [this.enumeration[type]]: value,
    };
    const res = await this.carService.getCarInfoEdit(data);
    if (res) {
      this.init();
      this.shopEditorRef.close();
    }
  }

  openMarket(field: ECarShopField, val: any) {
    // console.log(field, val);
    const target = Object.assign({}, this.shopFields[`${field}`]);

    target.value = val;
    this.editingField = target;

    setTimeout(() => {
      this.marketDrawerRef.open();
    }, 500);
  }

  async editMarket(param: { [key: string]: any }) {
    // console.log(param);
    const { market_id, sub_name } = param;
    const params = {
      marketId: market_id,
      subName: sub_name,
      car_shop_code: this.shopCode,
    };
    if (this.editType === '2') {
      const Obj = {
        marketId: market_id,
        subName: sub_name,
      };
      this.multipleData = Object.assign({}, this.multipleData, Obj);
      this.marketDrawerRef.close();
      return;
    }
    const res = await this.carService.postCarShopUpdateMarket(params);
    if (res) {
      this.$message.success('操作成功');
      this.init();
      this.marketDrawerRef.close();
    }
  }

  async asyncRightsOrder() {
    const res = await this.carService.postCarShopCancelRightsOrder({
      shop_code: this.shopCode,
    });
    if (res) {
      this.$message.success('操作成功');
      await this.init();
    }
  }

  async editShopLicense(param: { [key: string]: any }) {
    const val = Object.entries(param)[0];
    const type = val[0];
    let value = val[1];
    const { id } = this.$route.params;
    if (type === 'headPics' || type === 'coverPics' || type === 'shopLicense') {
      value = value.join(',');
    }
    const getRule = await this.SystemService.getRule(
      'certificate_address_distance_key',
    );
    const params = {
      imgId: val[1],
      shopId: this.shopDetail.carShopId,
      credName: '0301',
      new_edit: '1',
    };
    const CarAutoOff = await this.imageService.getCarAutoOffShelfTime(params);
    const data = {
      car_shop_code: id,
      [this.enumeration[type]]: value,
      certificateAddressDistance: CarAutoOff?.distance,
    };
    if (
      getRule &&
      (Number(getRule) < Number(CarAutoOff.distance) ||
        Number(CarAutoOff.distance) === -1)
    ) {
      const _text = `营业执照地址与门店地址偏移距离大于${getRule}米,后续需上传《经营地址租赁合同》或《不动产登记证》`;
      this.$confirm({
        title: '提示',
        content: _text,
        okText: '继续',
        cancelText: '取消',
        onOk: async () => {
          await this.transferModifyShop(data);
        },
        onCancel() {
          // console.log('Cancel');
        },
        class: 'test',
      });
    } else {
      await this.transferModifyShop(data);
    }
  }
  async transferModifyShop(data: any) {
    if (this.editType === '2') {
      this.hasUnsavedChanges = true;
      this.multipleData = Object.assign({}, this.multipleData, data);
      this.shopEditorRef.close();
      return;
    }
    const res = await this.carService.getCarInfoEdit(data);
    if (res) {
      this.init();
      this.shopEditorRef.close();
    }
  }

  async editShopAddress(param: { [key: string]: any }) {
    const val = Object.entries(param)[0];
    const value = val[1];
    // console.log(val);
    const { id } = this.$route.params;
    const { address, latitude, locationName, longitude, regions } = value;
    const data = {
      car_shop_code: id,
      address,
      latitude,
      location_name: locationName,
      longitude,
      regions,
      regionpid: regions[0] || '',
      regionid: regions[1] || '',
      adcode: regions[2] || '',
    };
    if (this.editType === '2') {
      this.hasUnsavedChanges = true;
      const Obj = {
        address,
        latitude,
        location_name: locationName,
        longitude,
        regions,
        regionpid: regions[0] || '',
        regionid: regions[1] || '',
        adcode: regions[2] || '',
      };
      this.multipleData = Object.assign({}, this.multipleData, Obj);
      this.shopEditorRef.close();
      return;
    }
    const res = await this.carService.getCarInfoEdit(data);
    if (res) {
      this.init();
      this.shopEditorRef.close();
    }
  }

  async openShopEditor(field: ECarShopField, val: any) {
    // console.log(field, val);
    const target = Object.assign({}, this.shopFields[`${field}`]);
    // console.log(target);

    target.value = val;
    this.editingField = target;
    // console.log(this.editingField);
    if (
      field === ECarShopField.TELS ||
      field === ECarShopField.MERCHANT_TELEPHONE
    ) {
      let text: any = '';
      let encrypt_phone: any = '';
      if (field === ECarShopField.MERCHANT_TELEPHONE) {
        text = '门店详情-行业电话编辑';
        encrypt_phone = this.shopDetail.encryptedMerchantTelephone;
      } else if (field === ECarShopField.TELS) {
        text = '门店详情-营业电话编辑';
        encrypt_phone = this.shopDetail.encryptedTels;
      }

      if (encrypt_phone) {
        const data = {
          encrypt_phone,
          operate_type: text,
          poi: this.shopDetail.poi,
        };
        const res = await this.carService.postPhoneDecrypt(data);
        this.editingField.value = res;
      }
    }

    if (field === ECarShopField.IDENTITY_NUM) {
      this.editingField.value = '';
    }

    if (field === ECarShopField.NAME) {
      const h = this.$createElement;
      this.$warning({
        title: '提示',
        content: h('div', { style: { color: 'red' } }, [
          h(
            'p',
            '修改店铺名称前请先验证门脸照，请确保店铺名称与门脸照上的文字基本一致',
          ),
        ]),
        onOk: () => {
          this.shopEditorRef.open();
        },
      });
      return;
    }

    setTimeout(() => {
      this.shopEditorRef.open();
    }, 500);
  }

  addEmitHelpers() {
    const { carShopId } = this.shopDetail;

    this.$router.push({
      name: 'carlist.index',
      params: {
        id: carShopId,
      },
    });
  }
  async init() {
    const { id } = this.$route.params;
    this.shopCode = id;
    const res: any = await this.carService.getCarShopDetail(id, this.$el);
    if (res) {
      this.shopDetail = res;
      const {
        regionpid,
        regionid,
        adcode,
        businessLicense,
        idCardInfo,
        carShopId,
      } = res;
      this.staff = res.staff;
      this.addressInfo = {
        locationName: res.name,
        address: res.address,
        regions: [regionpid, regionid, adcode],
        latitude: res.latitude,
        longitude: res.longitude,
      };
      if (businessLicense) {
        this.businessLicenseInfo = businessLicense;
      }
      if (idCardInfo) {
        this.idCardInfo = idCardInfo;
      }
      this.getAdvertiserInfo(carShopId);
    }
  }

  /** 修改营业状态 */
  async changeBusinessStatus(type: any) {
    if (this.isLoading === true) {
      return;
    }
    this.isLoading = true;
    this.businessControl.changeBusinessStatus(type);

    setTimeout(() => {
      this.isLoading = false;
    }, 300);
  }

  mounted() {
    this.init();
  }
  editInformation() {
    this.shoplLicenseModal.init();
  }
  editIdCardInfo() {
    this.idCardModal.init();
  }

  /** 编辑广告主手机号码 */
  async editAdvertiserPhoneNum(param: { [key: string]: string }) {
    const { carShopId } = this.shopDetail;
    if (!carShopId) {
      return;
    }
    const params = {
      shopId: carShopId,
      adPhone: param.advertiserMobilePhoneNumber,
    };
    const res = await this.carService.postCarShopBindShopRelation(params);
    if (res) {
      this.$message.success('操作成功');
      this.shopEditorRef.close();
      this.getAdvertiserInfo(carShopId);
    }
  }

  async getAdvertiserInfo(carShopId: string) {
    try {
      const res = await this.carService.getAdvertiserInfo({
        shopId: carShopId,
      });
      if (res) {
        this.advertiser = res;
      }
    } catch (error) {
      this.$message.error('获取广告主信息失败');
    }
  }

  async postCarShopBindShopRelation(carShopId: string) {
    try {
      const res = await this.carService.postCarShopBindShopRelation({
        shopId: carShopId,
      });
      if (res) {
        this.$message.success('操作成功');
        this.init();
      }
    } catch (error) {
      this.$message.error('绑定门店关系失败');
    }
  }
}
